import React from "react";

interface ProudToServeLogoProps {
	companyName: string;
	fileName: string;
	link: string;
}

export function ProudToServeLogo({
	companyName,
	fileName,
	link,
}: ProudToServeLogoProps) {
	return (
		<li>
			<a
				href={link}
				aria-label={`External link to the ${companyName} website`}
				target="_blank"
				rel="noopener noreferrer"
			>
				<img
					src={`/static/img/logos/${fileName}`}
					alt={`Logo ${companyName}`}
				/>
			</a>
		</li>
	);
}
